module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-12-db1dd4bd4c7ca3174c7609fb85b8eb18.jpg";